import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M16.07 13.879a1.788 1.788 0 1 0-3.455.926 1.788 1.788 0 0 0 3.454-.926ZM51.385 13.88a1.788 1.788 0 1 0-3.454.925 1.788 1.788 0 0 0 3.454-.926ZM16.07 49.195a1.788 1.788 0 1 0-3.454.926 1.788 1.788 0 0 0 3.454-.926ZM51.385 49.194a1.788 1.788 0 1 0-3.454.926 1.788 1.788 0 0 0 3.454-.925Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M53.975 53.975H10.024V10.024h43.951v43.951l3.996-1.07V6.027H9.524a3.496 3.496 0 0 0-3.496 3.496v44.95a3.496 3.496 0 0 0 3.496 3.497h45.522l-1.07-3.996Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M42.268 21.777a14.44 14.44 0 0 0-10.277-4.257 14.44 14.44 0 0 0-10.278 4.257 14.44 14.44 0 0 0-4.257 10.277 14.44 14.44 0 0 0 4.257 10.278 14.44 14.44 0 0 0 10.278 4.257 14.44 14.44 0 0 0 10.277-4.257 14.44 14.44 0 0 0 4.257-10.278 14.44 14.44 0 0 0-4.257-10.277Zm-10.277-1.26c2.487 0 4.79.786 6.674 2.125l-6.7 6.7-6.678-6.68a11.483 11.483 0 0 1 6.704-2.146ZM20.453 32.053c0-2.429.752-4.682 2.034-6.541l6.654 6.654-6.562 6.562a11.484 11.484 0 0 1-2.126-6.675Zm11.538 11.538c-2.443 0-4.706-.76-6.571-2.054l6.546-6.546 6.566 6.567a11.479 11.479 0 0 1-6.541 2.034v-.001Zm9.391-4.835-6.59-6.59 6.683-6.684a11.484 11.484 0 0 1 2.054 6.57 11.62 11.62 0 0 1-2.147 6.704Z"
        }
      )
    ]
  }
);
export {
  t as InternalDrains
};
